
import { getStorage, setStorage } from "../globals/storage";
import g from "../globals/variables";

const Loader = {

  init: () => {
    Loader.lazyLoadImages();
    document.addEventListener("DOMContentLoaded", Loader.hideLoader);
    // handling page restore for mobile iOS - without this back/forward buttons do not hide loader covers
    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        window.location.reload();
      }
    });
  },

  hideLoader: () => {
    g.el.header.querySelectorAll(".navigation--sidebar .navigation__item--active").forEach((item) => {
      if (item) g.el.loader.content.classList.add("loader__content--orange");
    });

    if (!getStorage("session", "s2aPageLoaded")) {
      // first page load
      setTimeout(() => {
        g.el.loader.layoutWhite.classList.add("loader__layout--out");
        setTimeout(() => {
          g.el.loader.layoutWhite.classList.add("loader__layout--hidden");
          g.el.loader.layoutGreen.classList.add("loader__layout--out");
          setTimeout(() => {
            g.el.loader.layoutGreen.classList.add("loader__layout--hidden");
            g.el.loader.content.classList.add("loader__content--out");
            g.el.layout.classList.add("layout--loaded");
            setTimeout(() => {
              g.el.loader.content.classList.add("loader__content--hidden");
            }, 300);
          }, 400);
        }, 400);
      }, 300);
    } else {
      g.el.loader.layoutGreen.classList.add("loader__layout--disabled");
      g.el.loader.layoutWhite.classList.add("loader__layout--disabled");
      setTimeout(() => {
        g.el.loader.content.classList.add("loader__content--out");
        g.el.layout.classList.add("layout--loaded");
        setTimeout(() => {
          g.el.loader.content.classList.add("loader__content--hidden");
        }, 300);
      }, 10);
    }

    setStorage("session", "s2aPageLoaded", true);
  },

  lazyLoadImages: () => {
    g.el.lazyImages.forEach((image) => {
      // TODO lazy loading fails to load in chrome
      image.setAttribute("data-image-loaded", "");
      // image.querySelector("img").addEventListener("load", () => {
      //   image.setAttribute("data-image-loaded", "");
      // });
    });
  },
};

export default Loader;
